import PropTypes from 'prop-types';

export const JobFormSaqTabPropTypes = {
  auth: PropTypes.object.isRequired,
  job: PropTypes.object.isRequired,
  jobId: PropTypes.object.isRequired,
  jobStatus: PropTypes.string.isRequired
};

export const JobFormSaqTabDefaultProps = {};
